import { CanActivateFn } from '@angular/router';

/**
 * Builds a CanActivateFn that does a full-page (not client-side) navigation to
 * `baseUrl` + the target route's path/query, then cancels the Angular
 * navigation by returning false — fine since the browser is already leaving
 * this app.
 *
 * Must read the target URL from `state.url`, not `window.location` — Angular
 * only commits the new URL to the browser once navigation succeeds, and this
 * guard cancels it, so `window.location` would still hold the *previous* URL.
 */
export function createExternalRedirectGuard(baseUrl: string): CanActivateFn {
  return (_route, state) => {
    window.location.href = `${baseUrl}${state.url}`;
    return false;
  };
}
